import _jsx from '@babel/runtime/helpers/esm/jsx';
import _styled from 'styled-components';
import { useCallback } from 'react';
import { createHydratableComponent } from '@dbh/hydration';
import { jsx } from 'react/jsx-runtime';

/*
 *
 * Constants: `@dbh/hydratable-select-with-links`.
 *
 */const COMPONENT_ID="dbh-search-order";

const SelectWithLinks=a=>{let{options:b,...c}=a;const d=useCallback(a=>{const{target:{value:c}}=a,d=b.find(a=>a.get("id")===c);d&&(location.href=d.get("url"));},[b]);return/*#__PURE__*/jsx(_StyledSelect,{...c,onChange:d,children:b.map(a=>/*#__PURE__*/_jsx("option",{value:a.get("id"),"data-url":a.get("url")},a.get("id"),a.get("label")))})};SelectWithLinks.displayName="SelectWithLinks";var index = createHydratableComponent(SelectWithLinks,{id:COMPONENT_ID,props:{immutable:["options","initialValues"]}});var _StyledSelect=/*#__PURE__*/_styled("select").withConfig({componentId:"sc-1fgsfkv-0"})(["display:block;width:100%;height:100%;"]);

export { COMPONENT_ID, index as default };
